export default __webpack_public_path__ + "images/0ba8019eb029f2bb876dfca61f897032-las_vegas_desktop.webp";